import React from 'react';

import CN from './ResponsiveBox.module.scss';

const Desktop = ({ children }) => (
  <div data-bem="ResponsiveBox--desktop" className={CN.desktopOnly}>
    {children}
  </div>
);

const Mobile = ({ children }) => (
  <div data-bem="ResponsiveBox--mobile" className={CN.mobileOnly}>
    {children}
  </div>
);

const ResponsiveBox = (props) => (
  <>
    <Desktop {...props} />
    <Mobile {...props} />
  </>
);

ResponsiveBox.Desktop = Desktop;
ResponsiveBox.Mobile = Mobile;

export default ResponsiveBox;
